import { Host, h } from '@stencil/core';
export class AibaWelcomeScreen {
  constructor() {
    this.getData = undefined;
    this.handlers = undefined;
    this.data = undefined;
    this.mockData = undefined;
    this.classes = undefined;
    this.styles = undefined;
    this.showWelcomeConfirmModal = false;
    this.showPrivacyModal = false;
    this.privacyStatementModalData = undefined;
    this.welcomeConfirmModalData = undefined;
  }
  toggleLoading(event) {
    let stateName = event['detail']['stateName'];
    let value = event['detail']['value'];
    this[stateName] = value;
  }
  async componentWillLoad() {
    if (this.getData) {
      let mainData = await this.getData();
      if (this.handlers && this.handlers.handlOnLoad) {
        mainData = this.handlers.handlOnLoad(mainData);
      }
      this.data = mainData === null || mainData === void 0 ? void 0 : mainData.data;
      this.classes = mainData === null || mainData === void 0 ? void 0 : mainData.classes;
      this.styles = mainData === null || mainData === void 0 ? void 0 : mainData.styles;
    }
    else {
      if (typeof this.mockData === 'string') {
        this.data = JSON.parse(this.mockData);
      }
    }
  }
  componentDidLoad() {
    var _a, _b;
    this.handlers && ((_a = this === null || this === void 0 ? void 0 : this.handlers) === null || _a === void 0 ? void 0 : _a.welcomeScreenDidLoadhandler) && ((_b = this === null || this === void 0 ? void 0 : this.handlers) === null || _b === void 0 ? void 0 : _b.welcomeScreenDidLoadhandler());
  }
  componentDidRender() {
    var _a, _b;
    this.handlers && ((_a = this === null || this === void 0 ? void 0 : this.handlers) === null || _a === void 0 ? void 0 : _a.welcomeScreenDidRenderhandler) && ((_b = this === null || this === void 0 ? void 0 : this.handlers) === null || _b === void 0 ? void 0 : _b.welcomeScreenDidRenderhandler());
  }
  async handleButtonClick(e, eventName) {
    this.handlers && this.handlers[eventName](e);
  }
  render() {
    return (h(Host, null, this.styles && h("style", null, this.styles), this.data &&
      this.data.map((component) => {
        if (component && component['name'] === 'aiba-label')
          return h("aiba-label", Object.assign({}, component['data']));
        if (component && component['name'] === 'aiba-modal')
          return h("aiba-modal", { modalPosition: "center", handlers: this.handlers });
        if (component && component['name'] === 'aiba-button')
          return h("aiba-button", Object.assign({}, component['data'], { handleClick: (e) => this.handleButtonClick(e, component['data']['handleClick']) }));
        if (component && component['name'] === 'aiba-hero-image')
          return h("aiba-hero-image", Object.assign({}, component['data']));
        if (component && component['name'] === 'aiba-icon')
          return h("aiba-icon", Object.assign({}, component['data']));
        if (component && component['name'] === 'aiba-content-block')
          return h("aiba-content-block", Object.assign({}, component, { handlers: this === null || this === void 0 ? void 0 : this.handlers }));
        if (component && component['name'] === 'aiba-analysis-steps')
          return h("aiba-analysis-steps", Object.assign({}, component['data'], { handlers: this === null || this === void 0 ? void 0 : this.handlers }));
        if (component && component['name'] === 'aiba-privacy-statement-modal') {
          this.privacyStatementModalData = component;
        }
        if (component && component['name'] === 'aiba-welcome-confirm-modal') {
          this.welcomeConfirmModalData = component;
        }
      }), (this.privacyStatementModalData || this.welcomeConfirmModalData) && this.showWelcomeConfirmModal && (h("aiba-selfie-steps", { class: "welcome_confirm_modal", handlers: this.handlers, data: this.showPrivacyModal ? this.privacyStatementModalData.data : this.welcomeConfirmModalData.data, id: this.showPrivacyModal ? this.privacyStatementModalData.id : this.welcomeConfirmModalData.id }))));
  }
  static get is() { return "aiba-welcome-screen"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-welcome-screen.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-welcome-screen.css"]
    };
  }
  static get properties() {
    return {
      "getData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "get-data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "mockData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "mock-data",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "data": {},
      "classes": {},
      "styles": {},
      "showWelcomeConfirmModal": {},
      "showPrivacyModal": {},
      "privacyStatementModalData": {},
      "welcomeConfirmModalData": {}
    };
  }
  static get listeners() {
    return [{
        "name": "toggle-welcome-screen-state",
        "method": "toggleLoading",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-welcome-screen.js.map
